import { createAction } from '@reduxjs/toolkit';

export const resetAppState = createAction('settings/resetState');
